import styled from "styled-components";

export const ViewPageContainer = styled.div`
  position: relative;
  padding: 12px 40px 50px 40px;
  color: rgb(32, 22, 44);
  font-size: 14px;
  background: #fff;
  border-radius: 24px;

  @media (max-width: 768px) {
    padding: 12px 25px 50px;
    font-size: 14px;
  }
`

export const ViewHeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const CompanyHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const CompanyLogo = styled.img`
  width: 300px;
  height: 300px;
  margin-right: 32px;

  object-fit: contain;

  @media (max-width: 768px) {
    width: 240px;
    height: 240px;
    margin-right: 0;
  }
`

export const CompanyTitle = styled.span`
  max-width: 450px;
  font-size: 2.5em;
  font-weight: 600;
  text-transform: uppercase;

  @media (max-width: 768px) {
    max-width: none;
    font-size: 1.9rem;
  }
`

export const CompanyStand = styled.div`
  position: absolute;
  top: 12px;
  right: 0px;
  padding: 3px 12px;

  font-size: 1.5em;
  font-weight: 600;

  color: #fff;
  background: #ef713a;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: fit-content;
    position: relative;
    top: 0;
    right: 0;

    margin-bottom: 1rem;

    &::before {
      content: 'Stand: ';
    }
  }
`

export const ViewBodyContainer = styled.div`
  display: flex;
  gap: 80px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 24px;
  }
`

export const CompanyDescription = styled.div`
  font-size: 1.5em;
  line-height: 1;
  flex-grow: 1;
`
